import ActionTypes from '../Action.types';
import { Account } from '../../types/Types';

type State = {
  accounts: Account[];
  isLoading: boolean;
  errMessage: string;
};

type Action = {
  type: string;
  payload: any;
};

function AccountReducer(state: State, action: Action): State {
  switch (action.type) {
    case ActionTypes.start:
      return { ...state, isLoading: true };
    // ------------------------------------------------------------------- //
    // ----------------------------- FIND ALL----------------------------- //
    // ------------------------------------------------------------------- //
    case ActionTypes.find:
      let getData: Account[] = action.payload.sort(
        (a: Account, b: Account) =>
          new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
      );

      getData = getData.map((d: any) => {
        console.log();
        return {
          ...d,
          id: d._id,
          type: d.type,
          status: d.status,
          createdAt: new Date(d.createdAt).toLocaleDateString('en-EN'),
          updatedAt: new Date(d.updatedAt).toLocaleDateString('en-EN'),
          updatedTime: new Date(d.updatedAt).toLocaleTimeString('th-TH'),
        };
      });

      return { ...state, isLoading: false, accounts: getData };

    // ------------------------------------------------------------------ //
    // ----------------------------- UPLOAD ----------------------------- //
    // ------------------------------------------------------------------ //
    case ActionTypes.upload:
      let uploadAccounts: any = [...state.accounts];
      action.payload.map((data: any) => uploadAccounts.push(data));
      return { ...state, isLoading: false, accounts: uploadAccounts };
    // ----------------------------------------------------------------------- //
    // ----------------------------- UPDATE----- ----------------------------- //
    // ----------------------------------------------------------------------- //
    case ActionTypes.update:
      return {
        ...state,
        isLoading: false,
        accounts: state.accounts.map((account) =>
          account.id === action.payload._id
            ? {
                ...action.payload,
                id: action.payload._id,
                type: action.payload.type,
                status: action.payload.status,
                createdAt: new Date(
                  action.payload.createdAt
                ).toLocaleDateString('en-EN'),
                updatedAt: new Date(
                  action.payload.updatedAt
                ).toLocaleDateString('en-EN'),
                updatedTime: new Date(
                  action.payload.updatedAt
                ).toLocaleTimeString('th-TH'),
              }
            : account
        ),
      };
    // ----------------------------------------------------------------------- //
    // ----------------------------- UPDATE MANY ----------------------------- //
    // ----------------------------------------------------------------------- //
    case ActionTypes.update_many:
      let editedMany: any = [];
      editedMany = state.accounts.map((account) => {
        if (action.payload.itemsId.includes(account.id)) {
          return {
            ...account,
            note: action.payload.editData.note
              ? action.payload.editData.note
              : account.note,
            type: action.payload.editData.type
              ? action.payload.editData.type
              : account.type,
            status: action.payload.editData.status
              ? action.payload.editData.status
              : account.status,
            updatedAt: new Date().toLocaleDateString('en-EN'),
            updatedTime: new Date().toLocaleTimeString('th-TH'),
            updatedBy: action.payload.editData.updatedBy,
          };
        }
        return account;
      });
      return { ...state, isLoading: false, accounts: editedMany };

    case 'EDIT_STOCK_AGENT':
      let editAgent: any = [];
      editAgent = state.accounts.map((account) => {
        if (action.payload.itemsId.includes(account.id)) {
          return {
            ...account,
            agent: action.payload.editData.agent,
          };
        }
        return account;
      });
      return { ...state, isLoading: false, accounts: editAgent };
    // ------------------------------------------------------------------ //
    // ----------------------------- DELETE ----------------------------- //
    // ------------------------------------------------------------------ //
    case ActionTypes.delete:
      return {
        ...state,
        accounts: state.accounts.filter(
          (account) => account.id !== action.payload
        ),
      };
    // ----------------------------------------------------------------------- //
    // ----------------------------- DELETE MANY ----------------------------- //
    // ---------------------------------------------------------------------- //
    case ActionTypes.delete_many:
      return {
        ...state,
        isLoading: false,
        accounts: state.accounts.filter(
          (account: any) => !action.payload.includes(account.id)
        ),
      };
    // ----------------------------- ERROR ----------------------------- //
    case ActionTypes.error:
      return { ...state, isLoading: false, errMessage: action.payload };
    // ----------------------------- CLEAR ----------------------------- //
    case ActionTypes.clear:
      return { ...state, isLoading: false, errMessage: '' };
    default:
      return state;
  }
}

export default AccountReducer;
